import { render, staticRenderFns } from "./PharmacySitesIndexComponent.vue?vue&type=template&id=2025c1e9"
import script from "./PharmacySitesIndexComponent.vue?vue&type=script&lang=js"
export * from "./PharmacySitesIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports